<div class="bg-white mb-5 py-3" *ngIf="showFilter">
  <div class="container-fluid">
    <div class="d-flex justify-content-between w-100">
      <strong class="pb-2 h5 d-block">Buscar por:</strong>

      <div class="align-self-center d-flex align-items-center">
        <ng-content select="[buttons]"></ng-content>
        <ng-container *ngIf="registerButton">
          <a *ngIf="!table?.actionPermissions?.edit; else addComPerm"
            [routerLink]="pathRegister"
            class="btn rounded-pill btn-sm btn-outline-primary"
            title="Adicionar {{ options.title }}">
            Adicionar
          </a>
          <ng-template #addComPerm>
            <a
              *ngxPermissionsOnly="table.actionPermissions.edit"
              [routerLink]="pathRegister"
              class="btn rounded-pill btn-sm btn-outline-primary"
              title="Adicionar {{ options.title }}">
              Adicionar
            </a>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <ng-content select="[filters]"></ng-content>

    <footer class="row">
      <div class="col-12 col-md-12">
        <button
          type="submit"
          (click)="submit()"
          title="Buscar"
          [disabled]="!canSubmit"
          class="btn rounded-pill btn-primary float-right ml-md-1 mb-2 col-md-auto"
        >
          <em class="fa fa-check"></em>
          Buscar
        </button>
        <button
          (click)="clearFilter()"
          title="Limpar"
          type="button"
          class="btn rounded-pill btn-outline-danger float-right ml-md-1 mb-2 col-md-auto"
        >
          <em class="fa fa-times"></em>
          Limpar
        </button>
      </div>
    </footer>
  </div>
</div>

<div class="container-fluid">
  <div
    class="card card-red rounded-bottom-custom box-rounded-bottom rounded-0 mt-3"
  >
    <div class="card-body border-top">
      <ng-content select="[header]"></ng-content>
      <div class="row">
        <div class="col-12">
          <app-table-custom
            id="table"
            [page]="page"
            [items]="items"
            [itemsPerPage]="itemsPerPage"
            [itemsPerPageOptions]="itemsPerPageOptions"
            [paginatorCustom]="paginatorCustom"
            (changePage)="changePage($event)"
            (changePageQtd)="changePageQtd($event)"
            [paginator]="showPaginator"
            [paginationId]="paginationId"
          >
            <ng-template appTableHeader>
              <tr>
                <th
                  *ngFor="let column of table.columns; let index = index"
                  [id]="column + '-column'"
                  class="text-{{column.align || 'left'}}">
                  {{ column.title }}
                  <em *ngIf="column.orderTo" class="fas fa-sort" (click)="orderColumn(column.orderTo)"></em>
                </th>

                <th id="col-3" class="table-columns-acoes" *ngIf="showActions || table.customActions">
                  {{ acao }}
                </th>
                <th *ngIf="isCrud" id="col-4">
                  Em uso
                </th>
              </tr>
            </ng-template>
            <ng-template appTableBody let-item let-index>
              <tr (click)="lineClicked(item)" >
                <ng-container *ngIf="!table.customColumns">
                  <ng-container *ngIf="!useInnerHtml" >
                    <td *ngFor="let column of table.columns" class="text-{{column.align || 'left'}}" >
                      {{ getValueColumn(item, column) }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="useInnerHtml" >
                    <td *ngFor="let column of table.columns" class="text-{{column.align || 'left'}}"  [innerHTML]="getValueColumn(item, column)">
                    </td>
                  </ng-container>

                </ng-container>
                <ng-container  *ngIf="table.customColumns">
                  <ng-container *ngTemplateOutlet="customColumns; context: {$implicit: item, index: index}"></ng-container>
                </ng-container>

                <td class="table-columns-acoes" *ngIf="showActions || table.customActions">
                  <ng-container *ngIf="expandable; else normalActions">
                    <button
                      type="button"
                      class="btn rounded-pill btn-default btn-sm"
                      [title]="isExpanded(index) ? 'Recolher' : 'Expandir'"
                      (click)="toggleExpand(index, $event)"
                    >
                      <em class="fas" [ngClass]="{ 'fa-chevron-up': isExpanded(index), 'fa-chevron-down': !isExpanded(index) }"></em>
                    </button>
                  </ng-container>
                  <ng-template #normalActions>
                    <ng-container *ngIf="table.actions.view">
                      <ng-container *ngIf="table.actionPermissions?.view?.length; else viewNoPerm">
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm mr-2"
                          title="Visualizar"
                          (click)="view(item)"
                          *ngxPermissionsOnly="table.actionPermissions.view"
                        >
                          <em class="fas fa-search"></em>
                        </button>
                      </ng-container>
                      <ng-template #viewNoPerm>
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm mr-2"
                          title="Visualizar"
                          (click)="view(item)"
                        >
                          <em class="fas fa-search"></em>
                        </button>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="table.actions.inactive">
                      <ng-container *ngIf="table.actionPermissions?.inactive?.length; else inactiveNoPerm">
                          <button type="button" class="btn btn-default btn-sm mr-2"
                          [title]="item.ativo ? 'Inativar' : 'Ativar'" (click)="inactive(item)"
                          *ngxPermissionsOnly="table.actionPermissions.inactive"
                        >
                          <em class="fas" [ngClass]="definirCorIcone(item)"></em>
                        </button>
                      </ng-container>
                      <ng-template #inactiveNoPerm>
                          <button type="button" class="btn btn-default btn-sm mr-2"
                          [title]="item.ativo ? 'Inativar' : 'Ativar'" (click)="inactive(item)">
                          <em class="fas" [ngClass]="definirCorIcone(item)"></em>
                        </button>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="table.actions.edit">
                      <ng-container *ngIf="table.actionPermissions?.edit?.length; else editNoPerm">
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm mr-2"
                          title="Editar"
                          (click)="edit(item)"
                          *ngxPermissionsOnly="table.actionPermissions.edit"
                        >
                          <em class="fas fa-pencil-alt"></em>
                        </button>
                      </ng-container>
                      <ng-template #editNoPerm>
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm mr-2"
                          title="Editar"
                          (click)="edit(item)"
                        >
                          <em class="fas fa-pencil-alt"></em>
                        </button>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="table.actions.delete">
                      <ng-container *ngIf="table.actionPermissions?.delete?.length; else deleteNoPerm">
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm"
                          title="Excluir"
                          (click)="delete(item)"
                          *ngxPermissionsOnly="table.actionPermissions.delete"
                        >
                          <em class="fas fa-trash"></em>
                        </button>
                      </ng-container>
                      <ng-template #deleteNoPerm>
                        <button
                          type="button"
                          class="btn rounded-pill btn-default btn-sm"
                          title="Excluir"
                          (click)="delete(item)"
                        >
                          <em class="fas fa-trash"></em>
                        </button>
                      </ng-template>
                    </ng-container>
                    <div class="form-check" *ngIf="table.actions.check">
                      <input id="checkbox" class="form-check-input" type="checkbox" (click)="check(item, $event.target.checked)">
                    </div>
                    <ng-container *ngIf="table.customActions">
                      <ng-container
                        *ngTemplateOutlet="
                          customActions;
                          context: { $implicit: item, index: index }
                        "
                      ></ng-container>
                    </ng-container>
                  </ng-template>
                </td>
                <td *ngIf="isCrud" class="text-center">
                  <button *ngIf="item.tabelasRelacionadas?.length" (click)="exibirTabelasRelacionadas(item)"
                    class="btn rounded-pill btn-default btn-sm" title="Em uso" id="btn-em-uso" type="button">
                    <em class="fas fa-check-circle text-primary">
                    </em>
                  </button>
                </td>
              </tr>
              <tr *ngIf="expandable && isExpanded(index)">
                <td [attr.colspan]="totalSubColumnsCount">
                  <table class="table mb-0 expanded-table" aria-describedby="tabela-expandida" id="table-expanded" >
                    <thead>
                      <tr>
                        <th *ngFor="let sub of table.subColumns" class="text-{{sub.align || 'center'}}">
                          {{ sub.title }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let subRow of getSubRows(item)">
                        <td *ngFor="let sub of table.subColumns" class="text-{{sub.align || 'center'}}">
                          {{ getValueSubColumn(subRow, sub) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-template>
            <ng-template appTableEmpty>
              <tr>
                <td [attr.colspan]="'100%'" class="text-center">
                  {{ emptyMessage }}
                </td>
              </tr>
            </ng-template>
          </app-table-custom>
        </div>
      </div>
    </div>
  </div>
</div>
